import { CLEAR_INFO, CLEAR_NOTIFICATION, CLEAR_ERROR, SET_INFO, SET_LOADING, SET_NOTIFICATION, SET_LOADING_ELEMENT_NAME, ADD_BANNER, REMOVE_BANNER, SET_MAJOR_UPDATE_MODAL } from '../types/contextTypes';

export default (state, action) => {
  switch (action.type) {
    case SET_INFO:
      return {
        ...state,
        info: action.payload,
      };
    case CLEAR_INFO:
      return {
        ...state,
        info: '',
      };
    case SET_NOTIFICATION:
      if (action.payload.type === 'error-stay') {
        return {
          ...state,
          error: action.payload.text,
          errorBoundary: action.payload.errorBoundary
        };
      }
      if (action.payload.type === 'info-stay') {
        return {
          ...state,
          information: action.payload.text
        };
      }
      return {
        ...state,
        notifications: [action.payload, ...state.notifications],
      };
    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
        errorBoundary: null
      };
    case CLEAR_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter((item) => item.id !== action.payload),
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
        loadingElementName: action.payload === false ? '' : state.loadingElementName,
      };
    case SET_LOADING_ELEMENT_NAME:
      return {
        ...state,
        loadingElementName: action.payload,
      };
    case ADD_BANNER:
      return {
        ...state,
        banners: [...state.banners, action.payload.banner]
      };
    case REMOVE_BANNER:
      return {
        ...state,
        banners: state.banners.filter(banner => banner.id !== action.payload.id)
      };
    case SET_MAJOR_UPDATE_MODAL:
      return {
        ...state,
        isMajorUpdateModalVisible: action.payload
    };
    default:
      return state;
  }
};
